import { CYCLE_DAYS, CycleDay } from 'domain/shared/newProject';

export const weeklyCycleMap: Record<CycleDay, CycleDay[]> = {
  [CYCLE_DAYS.MONDAY]: [CYCLE_DAYS.FRIDAY],
  [CYCLE_DAYS.TUESDAY]: [CYCLE_DAYS.MONDAY],
  [CYCLE_DAYS.WEDNESDAY]: [CYCLE_DAYS.TUESDAY],
  [CYCLE_DAYS.THURSDAY]: [CYCLE_DAYS.WEDNESDAY],
  [CYCLE_DAYS.FRIDAY]: [CYCLE_DAYS.THURSDAY],
};
export const demoMap: Record<CycleDay, CycleDay[]> = {
  [CYCLE_DAYS.MONDAY]: [CYCLE_DAYS.FRIDAY, CYCLE_DAYS.MONDAY],
  [CYCLE_DAYS.TUESDAY]: [CYCLE_DAYS.MONDAY, CYCLE_DAYS.TUESDAY],
  [CYCLE_DAYS.WEDNESDAY]: [CYCLE_DAYS.TUESDAY, CYCLE_DAYS.WEDNESDAY],
  [CYCLE_DAYS.THURSDAY]: [CYCLE_DAYS.WEDNESDAY, CYCLE_DAYS.THURSDAY],
  [CYCLE_DAYS.FRIDAY]: [CYCLE_DAYS.THURSDAY, CYCLE_DAYS.FRIDAY],
};
